import { ContentfulProductWithShopifyData, ShopifyCollection } from '@lib/types';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

const getLocalCollectionKey = (locale: string, handle: string) => `SHOPIFY-COLLECTION-${locale}-${handle}`;

const useShopifyCollection = (query: string, handle: string, locale: string = "en-US") => {
  const [state, setState] = useState<ContentfulProductWithShopifyData[]>();
  const [SWRData, setSWRData] = useState();

  const graphqlShopifyConfig = (queryBody: string) => ({
    async: true,
    crossDomain: true,
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
      'Content-Type': 'application/graphql',
    },
    body: queryBody,
  });

  const getCachedCollection = (locale: string, collectionHandle: string) => {
    const key = getLocalCollectionKey(locale, collectionHandle);
    const cached = sessionStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached);
    }
    return null;
  };

  const setCachedCollection = (locale: string, collectionHandle: string, collection: any) => {
    if(!collection) return;
    const key = getLocalCollectionKey(locale, collectionHandle);
    sessionStorage.setItem(key, JSON.stringify(collection));
  };

  async function shopifyQuery() {
    const data = await fetch(
      `https://hautehijab.myshopify.com/api/2021-10/graphql.json`,
      //@ts-ignore
      graphqlShopifyConfig(query)
    );
    const dataJson = await data.json();
    const productsWithContentfulData = dataJson?.data?.product?.products?.edges
    ?.filter(({ node: product }: any) => product.contentfulData)
    .map(({ node: product }: any) => ({
      ...product,
      ...JSON.parse(product.contentfulData.value),
      shopifyProduct: null,
    }))
    return productsWithContentfulData;
  }

  const { data: newSWRData, error } = useSWR(
    `${handle}_${locale}`,
    shopifyQuery,
    {
      refreshInterval: 5000,
    }
  );

  const fetchCollection = async () => {
    const cached = getCachedCollection(locale, handle);
    if (cached) {
      setState(cached);
    }
  };

  useEffect(() => {
    if(!handle || !locale) return;
    fetchCollection();
  }, [])

  useEffect(() => {
    if(newSWRData) {
      setCachedCollection(locale, handle, newSWRData);
      setState(newSWRData);
    }
  }, [newSWRData]);

  if(!handle || !locale) return;
  return state;
};

export default useShopifyCollection;
